$(function () {
  let calendarColumn = $('.calendar-column');
  let eventPostElements = $('.one_event', calendarColumn);
  let lastMonth = $('.last_month', calendarColumn);
  let nextMonth = $('.next_month', calendarColumn);

  const icon = L.icon({
    iconUrl: '/app/themes/agrotheme/images/map/map-marker.svg',
    iconSize: [48, 48],
    popupAnchor: [0, -22]
  });

  initializeMap();
  initializeSlider();
  initializeCalendar();

  function initializeMap() {
    let $map = $('#map');
    let start_geopostion = $map[0] ? $map[0].dataset : null;

    if (!start_geopostion) {
      return;
    }

    let map = L.map('map').setView([parseFloat(start_geopostion.latitude), parseFloat(start_geopostion.longitude)], 13);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    L.marker([parseFloat(start_geopostion.latitude), parseFloat(start_geopostion.longitude)], { icon: icon }).addTo(map);
  }

  function initializeSlider() {
    $('[data-toggle="event-page-slider"]').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 6000,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '100px 0px 0px',
      prevArrow: "",
      nextArrow: "<button type=\"button\" class=\"slick-next\"><i class=\"ico-arrow-right\"></i></button>",
    });

    $("<div class='lucent'></div>").insertBefore("div.slick-list");
  }

  function loadEventContents(url, eventId, doPushState = true) {
    eventPostElements.removeClass('active');
    const serviceElementToLoad = eventPostElements.filter(`[data-id="${eventId}"]`);
    serviceElementToLoad.addClass('active');

    return $.ajax({
      url: url,
      cache: false,
      beforeSend: function () {
        $("body").addClass("loading");
      },
      complete: function () {
        $("body").removeClass("loading");
      },
      success: function (html) {
        let descriptionColumn = $(html).find(".description-column")[0].innerHTML;
        let eventDetailsColumn = $(html).find(".event-details-column")[0].innerHTML;
        let title = html.match(/<title>(.*)<\/title>/)[1];
        document.title = $(`<span>${title}</span>`).text();
        let currentDescriptionColumn = $(document).find(".description-column");
        let currentEventDetailsColumn = $(document).find(".event-details-column");

        currentDescriptionColumn.html(descriptionColumn).wp_embed_ajax();
        currentEventDetailsColumn.html(eventDetailsColumn).wp_embed_ajax();

        initializeSlider();
        initializeMap();
        $('[data-toggle="scrollbar"]', currentDescriptionColumn).scrollbar();
        $('[data-toggle="scrollbar"]', currentEventDetailsColumn).scrollbar();

        currentDescriptionColumn.triggerAjaxLoaded();
        currentEventDetailsColumn.triggerAjaxLoaded();

        if (doPushState) {
          window.history.pushState({ url: url, eventId: eventId }, title, url);
        }
      }
    });
  }

  eventPostElements.on("click", function (e) {
    e.preventDefault();
    const $this = $(this);
    let url = this.parentElement.href;
    loadEventContents(url, $this.attr('data-id'));
    $("#event_calendar").datepicker("setDate", $this.attr('data-event'));
  });

  lastMonth.on("click", function (e) {
    $('.ui-datepicker-prev').click();
  });

  nextMonth.on("click", function (e) {
    $('.ui-datepicker-next').click();
  });

  window.addEventListener('popstate', (event) => {
    loadEventContents(event.state.url, event.state.eventId, false);
  });

  function addDays(date, days) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }

  function initializeCalendar() {
    let events = [];
    const dzien_milisekundy = 1000 * 60 * 60 * 24;

    let minDate = new Date();
    let maxDate = new Date();

    eventPostElements.each(function () {
      var dateEvent = new Date(this.dataset.event);
      var dateStart = new Date(this.dataset.start);
      var dateEnd = new Date(this.dataset.end ?? this.dataset.start);
      var days = Math.abs((dateStart.getTime() - dateEnd.getTime()) / dzien_milisekundy);

      minDate = minDate > dateStart ? dateStart : minDate;
      maxDate = maxDate < dateEnd ? dateEnd : maxDate;

      for (let i = 0; i <= days; i++) {
        events.push({
          Id: this.dataset.id,
          Title: this.dataset.title,
          Date: addDays(dateEvent, 0),
        });
      }

    });

    $("#event_calendar").datepicker({
      showOn: "both",
      buttonImageOnly: true,
      dateFormat: "mm/dd/yy",
      firstDay: 1,
      dayNamesMin: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "Sb"],
      monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
      disabled: false,
      minDate: minDate,
      maxDate: maxDate,
      onClose: function (selectedDate) {
        $("#to").datepicker("option", "minDate", selectedDate);
      },

      beforeShowDay: function (date) {
        var result = [true, '', null];
        var matching = $.grep(events, function (event) {
          return event.Date.valueOf() === date.valueOf();
        });

        if (matching.length) {
          result = [true, 'highlight', null];
        }

        return result;
      },

      onSelect: function (dateText) {
        var date,
          selectedDate = new Date(dateText),
          i = 0,
          event = null;
        while (i < events.length) {
          date = events[i].Date;

          serviceElementToLoad = eventPostElements.filter(`[data-id="${events[i].Id}"]`);
          if (selectedDate.valueOf() === date.valueOf()) {
            event = events[i];
            serviceElementToLoad.addClass('active');
          } else {
            serviceElementToLoad.removeClass('active');
          }
          i++;
        }
      },

      onChangeMonthYear: function (year, month) {
        var date,
          startMonth = new Date(year, month - 1, 1),
          endMonth = new Date(year, month - 1, getDaysInMonth(month, year)),
          i = 0;
        while (i < events.length) {
          date = events[i].Date;
          serviceElementToLoad = eventPostElements.filter(`[data-id="${events[i].Id}"]`);
          parentElement = serviceElementToLoad[0].parentElement;
          if (startMonth.valueOf() <= date.valueOf() && date.valueOf() <= endMonth) {
            $(parentElement).removeClass('hide');
          } else {
            $(parentElement).addClass('hide');
          }
          i++;
        }
      }
    });
  }

  function getDaysInMonth(m, y) {
    return m === 2 ? y & 3 || !(y % 25) && y & 15 ? 28 : 29 : 30 + (m + (m >> 3) & 1);
  }
});

